<template>
  <section class="content white large-padding">
    <form class="hide-for-print" @submit.prevent="handleSubmit" spellcheck="false">
      <TheLoader :active="true" v-if="loading"/>

      <fieldset style="margin: 0;">
        <div class="grid-x grid-padding-x">
          <TheSelectInput
            containerClassName="cell medium-4 large-2"
            label="Velg kategori"
            name="cat"
            v-model.trim="form.category"
            :items="kategoriOptions"
          />

          <div class="cell large-6">
            <DateFromTillForm
              v-model="form.dates"
              :labelFrom="'Dato f.o.m'"
              :labelTill="'Dato t.o.m'"
              :requiredFrom="true"
              :requiredTill="true"
            />
          </div>
          <div class="cell auto">
            <label>&nbsp;</label>
            <button v-if="fetching" class="button primary loading">Ok <span class="loader-spinner"></span></button>
            <button v-else class="button primary">Ok</button>
          </div>
        </div>
      </fieldset>
    </form>

    <div class="content-container flex-column">
      <div class="content-container flex-row content-x-scroll content-y-scroll table-results">
        <table class="large fixed sortable sticky-table-header color-rows" style="height: 0">
          <thead>
            <tr>
              <th class="align-left unsortable" style="font-weight: bold">Nettauksjon</th>
              <th class="align-center unsortable" style="font-weight: bold"></th>
              <th class="align-center unsortable" style="font-weight: bold">Med Bud</th>
              <th class="align-center unsortable" style="font-weight: bold">Uten Bud</th>
              <th class="align-right unsortable" style="font-weight: bold">Totalt</th>
            </tr>
          </thead>
          <tbody class="empty-container" v-if="items.length < 1">
            <tr>
              <td colspan="6">
                <em v-if="searched">Fant ingen data...</em>
                <em v-else>Søk med fra/til dato...</em>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr v-for="item in items" :key="item.Slutt">
              <td v-html="formatWeekName(item.Slutt)"></td>
              <td class="align-center" v-html="formatDate(item.Slutt)"></td>
              <td class="align-center">{{ item.medBud }}</td>
              <td class="align-center">{{ item.utenBud }}</td>
              <td class="align-right">{{ item.totalt }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
import moment from 'moment'
import DateFromTillForm from '@/components/Inputs/DateFromTillForm'
import StatistikkService from '@/services/StatistikkService'
import InstillingerService from '@/services/InstillingerService'
import MiscService from '@/services/MiscService'

export default {
  name: 'StatsProsentandelAvSalgsdagen',
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    DateFromTillForm
  },
  data () {
    return {
      loading: false,
      fetching: false,
      searched: false,
      avdelingOpts: [],
      items: [],
      form: {
        avdelingsid: null,
        dates: {
          from: null,
          till: null
        },
        category: null
      },
      kategoriOptions: [
        {key: 'endretAvSelgerIkkeProvd', val: 'Objekter endret av selger, ikke forsøkt'},
        {key: 'endretAvSelger', val: 'Objekter endret av selger'},
        {key: 'all', val: 'Alle'},
        {key: 'group_art', val: 'Kunst'},
        {key: 'group_books_and_maps', val: 'Bøker, Kart'},
        {key: 'group_other', val: 'Øvrige objekter'}
      ]
    }
  },
  computed: {
    submittable: function () {
      return !this.loading && !this.fetching && this.form.dates.from && this.form.dates.till
    }
  },
  mounted () {
    this.fetchSettings()
  },
  methods: {
    handleSubmit: function () {
      this.fetching = true
      this.getData()
    },
    fetchSettings: function () {
      this.loading = true

      this.avdelingOpts.unshift({key: null, val: 'Laster...'})

      InstillingerService('avdeling').dropdown()
        .then((response) => {
          this.avdelingOpts = response.data
          this.avdelingOpts.unshift({ key: null, val: 'Alle' })
        })
        .catch(() => {
          // Skip error
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste ned avdeling innstillinger')
        })
        .then(() => {
          this.loading = false
        })

      MiscService.loadDropdownKategori()
        .then((data) => {
          this.kategoriOptions = [
            {key: '', val: 'Velg kategori'},
            ...data
          ]
        })

      this.getData()
    },
    getData: function () {
      StatistikkService.loadProsentandelSalgsdagenJson(this.form.dates.from, this.form.dates.till, this.form.category)
        .then(response => {
          console.log(response)
          this.items = response.data
        })
        .catch(error => {
          console.log('Error')
          console.log(error)
          this.items = []
        })
        .then(() => {
          this.fetching = false
          this.searched = true
        })
    },
    formatWeekName: function (date) {
      let momentObj = ''
      let momentString = ''

      momentObj = moment(date, 'YYYY-MM-DD').locale('nb')
      momentString = momentObj.format('dddd')

      return momentString
    },
    formatDate: function (date) {
      let momentObj = ''
      let momentString = ''

      momentObj = moment(date, 'YYYY-MM-DD').locale('nb')
      momentString = momentObj.format('DD.MM')

      return momentString
    }
  }
}
</script>
<style scoped>
  table.fixed tbody.empty-container tr td:after {
    border: none;
    background-color: revert;
  }

  table.fixed tbody tr.footer td {
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Reports/Stats/StatsProsentandelAvSalgsdagen.vue